import { render, staticRenderFns } from "./StudentDocUploadSidebar.vue?vue&type=template&id=8fa6a03c&scoped=true&"
import script from "./StudentDocUploadSidebar.vue?vue&type=script&lang=js&"
export * from "./StudentDocUploadSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocUploadSidebar.vue?vue&type=style&index=0&id=8fa6a03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa6a03c",
  null
  
)

export default component.exports